<div class="booking-page">

  <!-- PAGE HEADER -->
  <div class="page-header">
    <button
      type="button"
      class="widowed-back-btn"
      (click)="goBack()"
      aria-label="Go back">
      <span class="material-symbols-outlined">arrow_back</span>
    </button>
    <div>
      <h2>My Wedding Bookings</h2>

      <p>
        View and manage your booked wedding services
      </p>
    </div>

    <div class="booking-count" *ngIf="bookings.length > 0">
      {{ bookings.length }} Booking{{ bookings.length > 1 ? 's' : '' }}
    </div>

  </div>


  <!-- EMPTY STATE -->
  <div
    class="empty-state"
    *ngIf="bookings.length === 0"
  >

    <span class="material-symbols-outlined">
      event_busy
    </span>

    <h3>
      No bookings available
    </h3>

    <p>
      You haven't booked any wedding services yet.
    </p>

  </div>



  <!-- BOOKINGS -->
  <div
    class="booking-list"
    *ngIf="bookings.length > 0"
  >

    <div
      class="booking-card"
      *ngFor="let booking of bookings"
    >


      <!-- ================================================= -->
      <!-- CARD TOP ROW -->
      <!-- ================================================= -->

      <div class="card-top">


        <!-- SERVICE -->
        <div class="service-info">

          <div class="service-title-row">

            <h3>
              {{ booking.service_name || 'Wedding Service' }}
            </h3>

            <span class="category-tag">
              {{ booking.category || 'Wedding Service' }}
            </span>

          </div>


          <!-- SERVICE DETAILS BUTTON -->

          <button
            type="button"
            class="btn-service-details"
            (click)="openServiceDetails(booking)"
          >

            <span class="material-symbols-outlined">
              info
            </span>

            Service Details

          </button>

        </div>



        <!-- STATUS AREA -->

        <div class="status-area">


          <!-- BOOKING STATUS -->

          <span
            class="status-badge"
            [ngClass]="{

              'status-confirmed':
              booking.booking_status === 'Confirmed',

              'status-pending':
              booking.booking_status === 'Pending',

              'status-rejected':
              booking.booking_status === 'Rejected'

            }"
          >

            <span
              class="material-symbols-outlined"
              *ngIf="booking.booking_status === 'Confirmed'"
            >
              check_circle
            </span>

            <span
              class="material-symbols-outlined"
              *ngIf="booking.booking_status === 'Pending'"
            >
              schedule
            </span>

            <span
              class="material-symbols-outlined"
              *ngIf="booking.booking_status === 'Rejected'"
            >
              cancel
            </span>

            {{ booking.booking_status || 'Pending' }}

          </span>



          <!-- PAYMENT STATUS -->

          <span
            class="status-badge payment-badge"
            *ngIf="booking.booking_status === 'Confirmed'"
            [ngClass]="
              'payment-' +
              (booking.payment_status || 'pending')
                .toLowerCase()
                .replace(' ', '-')
            "
          >

            <span
              class="material-symbols-outlined"
              *ngIf="booking.payment_status === 'Paid'"
            >
              task_alt
            </span>

            <span
              class="material-symbols-outlined"
              *ngIf="booking.payment_status === 'Advance Paid'"
            >
              payments
            </span>

            <span
              class="material-symbols-outlined"
              *ngIf="
                !booking.payment_status ||
                booking.payment_status === 'Pending'
              "
            >
              pending
            </span>

            {{ booking.payment_status || 'Payment Pending' }}

          </span>

        </div>

      </div>



      <!-- ================================================= -->
      <!-- DETAILS GRID -->
      <!-- ================================================= -->

      <div class="details-grid">


        <!-- CUSTOMER / VENDOR -->

        <div class="detail-box">

          <div class="box-label">

            <span class="material-symbols-outlined">
              store
            </span>

            Vendor

          </div>


          <p class="main-value">

            {{
              booking.merchantId?.business_name ||
              booking.merchantId?.businessName ||
              'N/A'
            }}

          </p>


          <p>

            <span class="material-symbols-outlined mini">
              category
            </span>

            {{ booking.category || 'Wedding Service' }}

          </p>


          <p>
  <span class="material-symbols-outlined mini">phone</span>
  {{ booking.merchantId?.phone ||
     booking.merchantId?.phone_number ||
     booking.merchantId?.mobile ||
     'N/A' }}
</p>


        </div>



        <!-- EVENT DETAILS -->

        <div class="detail-box">

          <div class="box-label">

            <span class="material-symbols-outlined">
              event
            </span>

            Event Details

          </div>


          <p class="main-value">

            <span class="material-symbols-outlined mini">
              calendar_month
            </span>

            {{
              booking.selectedDate?.day
            }}/{{ booking.selectedDate?.month }}/{{
              booking.selectedDate?.year
            }}

          </p>


          <p>

            <span class="material-symbols-outlined mini">
              location_on
            </span>

            {{ booking.location || 'Location not specified' }}

          </p>


          <p *ngIf="booking.function_name">

            <span class="material-symbols-outlined mini">
              celebration
            </span>

            {{ booking.function_name }}

          </p>


          <p
            class="notes"
            *ngIf="booking.additional_details"
          >

            <span class="material-symbols-outlined mini">
              notes
            </span>

            {{ booking.additional_details }}

          </p>

        </div>



        <!-- PAYMENT / BOOKING -->

        <div class="detail-box payment-box">

          <div class="box-label">

            <span class="material-symbols-outlined">
              payments
            </span>

            Payment Summary

          </div>


          <div class="amount-row">

            <span>
              Total Amount
            </span>

            <strong>
              ₹{{ booking.total_amount || booking.price || 0 }}
            </strong>

          </div>


          <div class="amount-row">

            <span>
              Advance Amount
            </span>

            <strong>
              ₹{{ booking.advance_amount || 0 }}
            </strong>

          </div>


          <div class="amount-row">

            <span>
              Paid Amount
            </span>

            <strong class="paid">
              ₹{{ booking.paid_amount || 0 }}
            </strong>

          </div>


          <div class="amount-row pending-row">

            <span>
              Pending Amount
            </span>

            <strong>
              ₹{{ booking.pending_amount || 0 }}
            </strong>

          </div>

        </div>


      </div>



      <!-- ================================================= -->
      <!-- BOOKING TIMELINE -->
      <!-- ================================================= -->

      <div class="booking-progress">

        <div class="progress-title">
          Booking Progress
        </div>


        <div class="progress-grid">


          <!-- REQUESTED -->

          <div class="progress-item">

            <span class="material-symbols-outlined success">
              event_available
            </span>

            <div>

              <strong>
                Requested
              </strong>

              <small
                *ngIf="booking.booked_on"
              >
                {{ booking.booked_on | date:'dd MMM yyyy, hh:mm a' }}
              </small>

            </div>

          </div>



          <!-- ACCEPTED -->

          <div
            class="progress-item"
            *ngIf="booking.accepted_on"
          >

            <span class="material-symbols-outlined success">
              check_circle
            </span>

            <div>

              <strong>
                Accepted
              </strong>

              <small>
                {{ booking.accepted_on | date:'dd MMM yyyy, hh:mm a' }}
              </small>

            </div>

          </div>



          <!-- ADVANCE PAID -->

          <div
            class="progress-item"
            *ngIf="booking.advance_paid_on"
          >

            <span class="material-symbols-outlined warning">
              payments
            </span>

            <div>

              <strong>
                Advance Paid
              </strong>

              <small>
                ₹{{ booking.advance_amount }}

                <br>

                {{ booking.advance_paid_on | date:'dd MMM yyyy, hh:mm a' }}
              </small>

            </div>

          </div>



          <!-- FULLY PAID -->

          <div
            class="progress-item"
            *ngIf="booking.payment_completed_on"
          >

            <span class="material-symbols-outlined success">
              task_alt
            </span>

            <div>

              <strong>
                Payment Completed
              </strong>

              <small>
                {{ booking.payment_completed_on | date:'dd MMM yyyy, hh:mm a' }}
              </small>

            </div>

          </div>



          <!-- REJECTED -->

          <div
            class="progress-item rejected"
            *ngIf="booking.rejected_on"
          >

            <span class="material-symbols-outlined danger">
              cancel
            </span>

            <div>

              <strong>
                Rejected
              </strong>

              <small>
                {{ booking.rejected_on | date:'dd MMM yyyy, hh:mm a' }}
              </small>

            </div>

          </div>

        </div>

      </div>



      <!-- REJECTION REASON -->

      <div
        class="rejection-note"
        *ngIf="
          booking.booking_status === 'Rejected' &&
          booking.reject_reason
        "
      >

        <span class="material-symbols-outlined">
          info
        </span>

        <span>
          Reason given: {{ booking.reject_reason }}
        </span>

      </div>


    </div>

  </div>

</div>



<!-- SERVICE DETAILS POPUP -->

<div
  class="overlay"
  *ngIf="showServiceDetails"
  (click)="closeServiceDetails()"
>

  <div
    class="service-modal"
    (click)="$event.stopPropagation()"
  >

    <!-- MODAL HEADER -->

    <div class="modal-header">

      <div>

        <span class="modal-label">
          SERVICE DETAILS
        </span>

        <h2>
          {{ selectedBooking?.serviceId?.service_name ||
             selectedBooking?.service_name ||
             'Wedding Service' }}
        </h2>

      </div>

      <button
        type="button"
        class="close-btn"
        (click)="closeServiceDetails()"
      >
        <span class="material-symbols-outlined">
          close
        </span>
      </button>

    </div>


    <!-- MODAL BODY -->

    <div
      class="modal-body"
      *ngIf="selectedBooking"
    >

      <!-- DESCRIPTION -->

      <div class="description-section">

        <h4>
          <span class="material-symbols-outlined">
            description
          </span>

          About this Service
        </h4>

        <p>
          {{
            selectedBooking?.serviceId?.service_description ||
            selectedBooking?.serviceId?.description ||
            selectedBooking?.service_description ||
            selectedBooking?.description ||
            'No description provided'
          }}
        </p>

      </div>


      <!-- SERVICE INFORMATION -->

      <div class="service-info-grid">


        <!-- PRICE -->

        <div class="service-info-box">

          <span class="material-symbols-outlined">
            sell
          </span>

          <div>

            <small>
              Price
            </small>

            <strong>
              ₹{{ selectedBooking?.total_amount ||
                  selectedBooking?.price ||
                  selectedBooking?.serviceId?.price ||
                  0 }}
            </strong>

          </div>

        </div>


        <!-- DURATION -->

        <div class="service-info-box">

          <span class="material-symbols-outlined">
            schedule
          </span>

          <div>

            <small>
              Duration
            </small>

            <strong>
              {{
                selectedBooking?.serviceId?.duration ||
                selectedBooking?.duration ||
                'Not specified'
              }}
            </strong>

          </div>

        </div>


        <!-- PAYMENT -->

        <div class="service-info-box">

          <span class="material-symbols-outlined">
            payments
          </span>

          <div>

            <small>
              Payment Type
            </small>

            <strong>
              {{
                selectedBooking?.serviceId?.payment?.type ||
                selectedBooking?.payment_type ||
                'Not specified'
              }}
            </strong>

          </div>

        </div>


        <!-- LOCATION -->

        <div class="service-info-box">

          <span class="material-symbols-outlined">
            location_on
          </span>

          <div>

            <small>
              Locations
            </small>

            <strong>

              {{
                selectedBooking?.serviceId?.service_locations?.join(', ') ||
                selectedBooking?.service_locations?.join(', ') ||
                selectedBooking?.location ||
                'Not specified'
              }}

            </strong>

          </div>

        </div>

      </div>


      <!-- INCLUDED -->

      <div
        class="included-section"
        *ngIf="selectedBooking?.serviceId?.included?.length"
      >

        <h4>

          <span class="material-symbols-outlined">
            check_circle
          </span>

          What's Included

        </h4>


        <div class="included-list">

          <div
            class="included-item"
            *ngFor="
              let item of selectedBooking.serviceId.included
            "
          >

            <span class="material-symbols-outlined">
              check
            </span>

            <span>
              {{ item }}
            </span>

          </div>

        </div>

      </div>


    </div>

  </div>

</div>